import { render, staticRenderFns } from "./DeveloperSettings.vue?vue&type=template&id=3b7f8227&scoped=true"
import script from "./DeveloperSettings.vue?vue&type=script&lang=js"
export * from "./DeveloperSettings.vue?vue&type=script&lang=js"
import style0 from "./DeveloperSettings.vue?vue&type=style&index=0&id=3b7f8227&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7f8227",
  null
  
)

export default component.exports